/* ----------  Ajax Code ---------- */

	$(document).on("submit",'form[action="/cart/add"]',function(e){
    e.preventDefault();
      var p_data = $( this ).serialize();
      $.ajax({
        type: "POST",
        context: this,
        url: '/cart/add.js',
        data: p_data,
        dataType: 'json',
        success: function(response){
           min_cart(); 
          $('.cart-nav').trigger("click");
        }
      });
      cartloader();
    //min_cart();
  });



  /*START: UPDATE CART WHEN PAGEFLY ITEM IS ADDED*/
  const slidecartPagefly = setInterval(function () {
    if (window.__pagefly_helper_store__) {
      window.__pagefly_helper_store__.subscribe(function () {
        min_cart();
      })

      clearInterval(slidecartPagefly)
    }
  }, 100)

  setTimeout(() => {
      clearInterval(slidecartPagefly)
  }, 5000)
  /*END: UPDATE CART WHEN PAGEFLY ITEM IS ADDED*/
  

    $(document).on("click", '.qtyplus', function(e) {
        e.preventDefault();
        var $input = $(this).parent().parent().find('input[name="quantity"]');
        var count = parseInt($input.val());
        var plus_qty = count + 1;
        var vid = $(this).attr('data-line-id');
        updateQuantity($input, plus_qty, vid);
    });

    $(document).on("click", '.qtyminus', function(e) {
        e.preventDefault();
        var $input = $(this).parent().parent().find('input[name="quantity"]');
        var count = parseInt($input.val());
        var minus_qty = count - 1;
        var vid = $(this).attr('data-line-id');
        updateQuantity($input, minus_qty, vid);
    });

    $(document).on("change", '.quantity-input', function(e) {
        var $input = $(this);
        var new_qty = parseInt($input.val());
        var vid = $input.attr('data-line-id');
        updateQuantity($input, new_qty, vid);
    });

    function updateQuantity($input, new_qty, vid) {
        if (isNaN(new_qty) || new_qty < 0) {
            new_qty = 0;
        }
        var p_data = {
            line: vid,
            quantity: new_qty
        };
        $.ajax({
            type: "POST",
            url: '/cart/change.js',
            data: p_data,
            dataType: 'json',
            success: function(response) {
                min_cart();
            }
        });
        cartloader();
        $input.val(new_qty);
    }

    $(document).on("click", ".qtydelete", function(e) {
        e.preventDefault();
        var vid = $(this).attr('data-cart-remove-id');
        var p_data = {
            id: vid,
            quantity: 0
        };
        $.ajax({
            type: "POST",
            url: '/cart/change.js',
            data: p_data,
            dataType: 'json',
            success: function(response) {
                min_cart();
            }
        });
        cartloader();
    });

function min_cart(){
    $.ajax({
      url:'/',
      type:'GET',
      success: function(data){
        $('.lb-header-cart').html($(data).find('.lb-header-cart').html());
        $('.lb-cart-drawer-box-header-carticon').html($(data).find('.lb-cart-drawer-box-header-carticon').html());
        $('.lb-cart-drawer-footer').html($(data).find('.lb-cart-drawer-footer').html());
        $('.lb-cart-drawer-item-box').html($(data).find('.lb-cart-drawer-item-box').html());
        $('.lb-cart-drawer-empty').html($(data).find('.lb-cart-drawer-empty').html());
        $('.lb-cart-drawer-preinfo-holder').html($(data).find('.lb-cart-drawer-preinfo-holder').html());
        $('.lb-cart-freeshipping-bar-holder').html($(data).find('.lb-cart-freeshipping-bar-holder').html());
        $('.staffelbox1').html($(data).find('.staffelbox1').html());
      }
    });  
  }


function cartloader(){
                  $(".lb-cart-drawer-box-loader").addClass("lb-cart-drawer-box-loader-animate").delay(500).queue(function(next ){
     $(".lb-cart-drawer-box-loader").removeClass("lb-cart-drawer-box-loader-animate");
     next();
  })
  }





/* ----------  Scripts for opener ---------- */

/*  Overlay upper closer  */  
$(".lb-cart-drawer-closer-upper").click( function lb_overlay_closer() {
$(".lb-cart-drawer-overlay-upper").removeClass("lb-cart-drawer-overlay-active");
$(".lb-cart-drawer-box").removeClass("lb-cart-drawer-box-active");
$(".lb-cart-drawer-overlay-under").removeClass("lb-header-search-bar-active");
$(".lb-mobile-nav").removeClass("lb-mobile-nav-active");
});

/*  Overlay under opener  */  
$(".lb-cart-drawer-closer-under").click( function lb_overlay_closer_under() {
$(".lb-cart-drawer-overlay-under").toggleClass("lb-cart-drawer-overlay-active");
$(".lb-header-search-bar").toggleClass("lb-header-search-bar-active");
});
    
/*  Cart opener  */
$(".lb-cart-drawer-opener").click( function lb_cart_opener() {
$(".lb-cart-drawer-box").addClass("lb-cart-drawer-box-active");
$(".lb-cart-drawer-overlay-upper").addClass("lb-cart-drawer-overlay-active");
});
  
/*  Search opener  */
$(".lb-header-search-icon").click( function lb_search_opener() {
$(".lb-header-search-bar").toggleClass("lb-header-search-bar-active");
$(".lb-cart-drawer-overlay-under").toggleClass("lb-cart-drawer-overlay-active");
});
  
/*  Mobile Navigation opener  */
$(".lb-header-burger-menu").click( function lb_nav_opener() {
$(".lb-cart-drawer-overlay-upper").addClass("lb-cart-drawer-overlay-active");
$(".lb-mobile-nav").addClass("lb-mobile-nav-active");
});

/*  Mobile Sub Navigation opener  */
$(".lb-mobile-nav-main-item-link").click( function lb_nav_opener() {
$(this).next(".lb-mobile-nav-sub-item").toggleClass("lb-mobile-nav-sub-item-active");
$(this).children(".lb-mobile-nav-main-item-arrow").toggleClass("lb-mobile-nav-main-item-arrow-active");
});

/*  Desktop Navigation Overlay  */
$(".lb-header-nav-main-inner-item-sub").mouseenter( function lb_nav_sub_opener_in() {
$(".lb-cart-drawer-overlay-under").addClass("lb-cart-drawer-overlay-active");
});

$(".lb-header-nav-main-inner-item-sub").mouseleave( function lb_nav_sub_opener_out() {
$(".lb-cart-drawer-overlay-under").removeClass("lb-cart-drawer-overlay-active");
$(".lb-header-search-bar").removeClass("lb-header-search-bar-active");
});

/*  Reset Password  */
$(".lb-reset-password").click( function lb_reset_password() {
$(".lb-password-reset-form").toggleClass("lb-password-reset-form-active");
});


 